import HubspotForm from 'react-hubspot-form'

const ContactSection = () => {
    return (
        <>
            <section className="faq__area pt-100 pb-100 theme-bg" id="contact">
                <div className="container bg-white p-lg-5 p-30">
                    <div className="row align-items-center">
                        <div className="col-md-5">
                            <h4>Option 1: <small>Want to explore the demo yourself?</small></h4>
                            <p>Get instant access to our demo and experience the platform at your own pace. No scheduling required—just click and start exploring.</p>
                            <a href="https://demo.elearningsaas.com/" rel="noreferrer" target="_blank" className="btn btn-success">
                                Explore Demo
                            </a>
                            <hr className="mt-40 mb-40" />
                            <h4>Option 2: <small>Live Demo with Expert:</small></h4>
                            <p>Prefer a guided walkthrough? Reserve your spot for a personalized product demo here</p>
                            <a
                                href="https://calendar.app.google/vF2pLFknmmp3jtjZ6"
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-warning"
                            >
                                Schedule Meeting
                            </a>
                            <hr className="mt-40 mb-40" />
                            <h4>Option 3: <small>Whatsapp Connect:</small></h4>
                            <p>Chat with us instantly on WhatsApp and get your questions answered in real time.</p>
                            <a
                                href="https://api.whatsapp.com/send?phone=+917583837735&text=Hello,%20Sending%20you%20message%20from%20https://landing.elearningsaas.com/"
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-info text-white"
                            >
                                Whatsapp
                            </a>
                        </div>
                        <div className="col-md-7">
                            <div className="text-center mt-lg-0 mt-50">
                                <h4>Get a Quote & Kickstart Your E-Learning Solutions Today!</h4>
                                <p className="mt-4 mb-4">
                                    Discover a smarter way to drive growth and efficiency with our cloud-based E-Learning solutions. Your journey to a brighter future starts now!
                                </p>
                            </div>
                            <div className="p-4 border">
                                <HubspotForm
                                    portalId="7805960"
                                    formId="ebfdd18c-a48b-4f60-9133-8c5e5b5b8157"
                                    region="na1"
                                    loading={<div>Loading...</div>}
                                    onSubmit={() => console.log("Header form submitted!")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ContactSection;